import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay", "title", "list", "panel", "backBtn"]

  #dirty = false

  open({ params: { filterLabel, filterPanel } }) {
    this.#setTitle(filterLabel)
    this.#showPanel(filterPanel)
    this.#show()
  }

  openList() {
    this.#setTitle("Filters & Sort")
    this.#showList()
    this.#show()
  }

  navigate({ params: { filterLabel, filterPanel } }) {
    this.#setTitle(filterLabel)
    this.#showPanel(filterPanel)
  }

  back() {
    this.#setTitle("Filters & Sort")
    this.#showList()
  }

  markDirty() {
    this.#dirty = true
  }

  close() {
    if (this.#dirty) this.#applyAllFilters()
    this.#closeDrawer()
  }

  get #form() {
    return this.element.querySelector("form[data-controller='side-filter']")
  }

  #applyAllFilters() {
    const sideFilter = this.application.getControllerForElementAndIdentifier(this.#form, "side-filter")
    sideFilter?.applyFilters()
  }

  disconnect() {
    document.body.style.overflow = ""
    document.body.style.overscrollBehavior = ""
  }

  #show() {
    this.#dirty = false
    this.overlayTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
    document.body.style.overscrollBehavior = "contain"
  }

  #closeDrawer() {
    this.overlayTarget.classList.add("hidden")
    document.body.style.overflow = ""
    document.body.style.overscrollBehavior = ""
  }

  #setTitle(label) {
    this.titleTarget.textContent = label
  }

  #showPanel(panelName) {
    this.listTarget.classList.add("hidden")
    this.panelTargets.forEach(p => p.classList.toggle("hidden", p.dataset.panel !== panelName))
    this.backBtnTarget.classList.remove("hidden")
    this.titleTarget.classList.remove("pl-10")
  }

  #showList() {
    this.listTarget.classList.remove("hidden")
    this.panelTargets.forEach(p => p.classList.add("hidden"))
    this.backBtnTarget.classList.add("hidden")
    this.titleTarget.classList.add("pl-10")
  }
}
